<template>
  <BulletList
    v-if="el.parent?.tagName !== Tags.LI"
    class="list"
    :list-type="getListType(el)"
    :list-items="getListItems(el)"
    :styles="el.attributes.style?.length ? el.attributes.style : ''"
  ></BulletList>
</template>
<script setup lang="ts">
import BulletList from '~/components/components/core/bullet-list/bullet-list.vue';
import type { HTMLElementSimplified } from '@/components/components/cms/wysiwyg/types';
import { EListType, type IListItem } from '~/@types/bullet-list';
import { Tags } from '../../../types';

defineProps({
  el: {
    type: Object as PropType<HTMLElementSimplified>,
    required: true,
    default: () => ({}) as HTMLElementSimplified,
  },
});

const map: Record<string, EListType> = {
  'checkmarks-dark-green': EListType.CheckMarksDarkGreen,
  'checkcircles-dark-green': EListType.CheckCirclesDarkGreen,
  'checkmarks-grey': EListType.CheckMarksGrey,
  'checkcircles-grey': EListType.CheckCirclesGrey,
  'checkmarks-light-green': EListType.CheckMarksLightGreen,
  'checkcircles-light-green': EListType.CheckCirclesLightGreen,
  'checkmarks-red': EListType.CheckMarksRed,
  'checkcircles-red': EListType.CheckCirclesRed,
  'checkmarks-brown': EListType.CheckMarksBrown,
  'checkmarks-purple': EListType.CheckMarksPurple,
  'checkcircles-purple': EListType.CheckCirclesPurple,
};

function getListType(el: HTMLElementSimplified): EListType {
  if (el.tag === 'OL') {
    return EListType.Number;
  } else {
    const key = Object.keys(map).find((key) => el.classList.contains(key));
    if (map[key]) return map[key];
  }
  return EListType.Bullet;
}

function getListItems(el: HTMLElementSimplified): IListItem[] {
  return el.children.reduce((acc, cur) => {
    if (cur.tag === Tags.LI) {
      acc.push({
        text: cur.innerHTML,
      });
    }
    return acc;
  }, [] as IListItem[]);
}
</script>
<style scoped lang="postcss">
.list {
  :deep(ul),
  :deep(ol) {
    @apply pt-2xs pb-2xs;
  }
}
</style>
